import React from 'react';
import { Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import { faHome } from '@fortawesome/free-solid-svg-icons';

const Error404 = () => {
  return (
    <Card className="text-center">
      <Card.Body className="p-5">
        <div className="display-1 text-300 fs-error">404</div>
        <p className="lead mt-4 text-800 font-sans-serif fw-semibold">
          The page you're looking for is not found.
        </p>
        <hr />
        <p>
          Make sure the address is correct and that the page hasn't moved. If
          you think this is a mistake,
          <a href="mailto:info@exmaple.com" className="ms-1">
            contact us
          </a>
          .
        </p>
        <a 
          className="btn btn-primary btn-sm mt-3" 
          href={`${window.location.origin}/authentication/simple/login`}
          onClick={() => {
            // 로컬 토큰들도 정리
            localStorage.removeItem('oidc_access_token');
            localStorage.removeItem('oidc_refresh_token');
            localStorage.removeItem('oidc_id_token');
            sessionStorage.removeItem('accessToken');
            sessionStorage.removeItem('refreshToken');
            sessionStorage.removeItem('siteToken');
            sessionStorage.removeItem('token');
            sessionStorage.removeItem('checkorg');
            sessionStorage.removeItem('checkorg_companyId');
            localStorage.removeItem('checkorg');
            localStorage.removeItem('checkorg_companyId');
          }}
        >
          <FontAwesomeIcon icon={faHome} className="me-2" />
          Take me home
        </a>
      </Card.Body>
    </Card>
  );
};

export default Error404;
